import UserProductGroupNotificationSettings from '~/Api/User/ProductGroup/NotificationSettings/UserProductGroupNotificationSettings';

export default class UserProductGroupNotification {
	settings: UserProductGroupNotificationSettings;

	constructor(settings: UserProductGroupNotificationSettings) {
		this.settings = settings;
	}

	settingsUpdated(settings: UserProductGroupNotificationSettings): UserProductGroupNotification {
		return new UserProductGroupNotification(settings);
	}
}
